import basketApi from 'services/api/basket';
import samplesReducer from 'reducers/samples';
import store from 'store/Store';
import decorators from 'utils/decorators';

const { ACTION_TYPES: TYPES } = samplesReducer;

function setSamples(samples) {
    return {
        type: TYPES.SET_SAMPLES,
        samples: samples
    };
}

// TODO: Update the fetch to be handled in the Store
function fetchSamples() {
    const { user } = store.getState();

    return dispatch => {
        return decorators
            .withInterstice(basketApi.getSamples)({ user })
            .then(data => {
                dispatch(setSamples(data));
            });
    };
}

export default {
    TYPES,
    fetchSamples,
    setSamples
};
